export default __webpack_public_path__ + "static/media/3.2eaf05ef.jpg";